import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
  SimpleChanges,
} from "@angular/core";
import { Dictionary } from "src/app/store/models/common_types";
import * as dayjs from "dayjs";

@Component({
  selector: "app-revision-period-select",
  templateUrl: "./revision-period-select.component.html",
  styleUrls: ["./revision-period-select.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class RevisionPeriodSelectComponent implements OnInit {
  @Input() selectedRevision: string;
  @Input() createChart: boolean;
  @Output() onChange: EventEmitter<string> = new EventEmitter();
  @Input() disabled: boolean;
  @Input() placeholder = "Select Revision";
  customDate = null;
  inValidCustomDate = false;
  popoverOpen = false;
  revFilterVisible = false;
  revisionPeriodList: Array<Dictionary<string>> = [
    { label: "3 months", value: "3m" },
    { label: "6 months", value: "6m" },
    { label: "12 months", value: "12m" },
  ];
  displaySelectedVal = "";
  revPeriodApplied = false;
  dateStr;

  ngOnInit() {
    this.setDisplayVal();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.selectedRevision &&
      changes.selectedRevision.currentValue !==
        changes.selectedRevision.previousValue
    ) {
      this.selectedRevision = changes.selectedRevision.currentValue;
      this.inValidCustomDate = false;
      this.setDisplayVal();
    }
  }

  onRevisionChange(newRevision: string) {
    this.selectedRevision = newRevision;
    this.onChange.emit(newRevision);
    this.customDate = null;
    this.inValidCustomDate = false;
    const selectedPeriod = this.revisionPeriodList.filter(
      (el) => el.value === newRevision,
    );
    this.displaySelectedVal = selectedPeriod[0] && selectedPeriod[0]["label"];
    this.revFilterVisible = false;
    this.revPeriodApplied = true;
  }

  popoverChange() {
    this.popoverOpen = !this.popoverOpen;
    if (this.popoverOpen) {
      this.revPeriodApplied = false;
    }
    if (!this.popoverOpen && !this.revPeriodApplied) {
      this.resetVal();
    }
  }

  onDateChange() {
    if (this.customDate === null) {
      this.inValidCustomDate = true;
    } else {
      this.revFilterVisible = false;
      this.dateStr = dayjs(this.customDate).format("MM-DD-YYYY");
      this.selectedRevision = `custom|${this.dateStr}`;
      this.onChange.emit(`custom|${this.dateStr}`);
      this.displaySelectedVal = this.dateStr;
      this.inValidCustomDate = false;
      this.revPeriodApplied = true;
    }
  }

  disabledCustomDate = (customValue: Date): boolean => {
    return customValue >= dayjs().toDate();
  };

  setDisplayVal() {
    if (this.selectedRevision && this.selectedRevision.startsWith("custom")) {
      this.displaySelectedVal = this.selectedRevision.split("|")[1];
      this.customDate = this.displaySelectedVal;
    } else {
      const selectedPeriod = this.revisionPeriodList.filter(
        (el) => el.value === this.selectedRevision,
      );
      this.displaySelectedVal = selectedPeriod[0] && selectedPeriod[0]["label"];
    }
  }

  resetVal() {
    this.customDate = this.dateStr;
    this.inValidCustomDate = false;
  }
}
